/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2016, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * A directive that generates AutoSaveService requests after a change in value
 */
angular.module('bulbApp.autoSaveModule')
  .directive('bulbAutoSave', [
    '$log',
    '$parse',
    '$rootScope',
    'Restangular',
    'BulbAutoSaveService',
    'SerialSaveService',
    'UnitStateStore',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    bulbAutoSave,
  ]);

function bulbAutoSave($log, $parse, $rootScope, Restangular, BulbAutoSaveService, SerialSaveService, UnitStateStore) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attrs, ngModelController) {
      let autoSaveConfig;
      let usingCustomSave = false;
      try {
        autoSaveConfig = scope.$eval(attrs.bulbAutoSave);
        if (!angular.isObject(autoSaveConfig)) {
          throw new Error('bulb-auto-save\'s value must be an Object, with restCollection and restId fields');
        }
      } catch (exception) {
        $log.error(exception.message);
        throw new Error('bulb-auto-save\'s value must be an Object, with restCollection and restId fields');
      }

      // a customSave function is sufficient configuration if it is provided
      if (angular.isFunction(autoSaveConfig.customSave)) {
        usingCustomSave = true;
      }

      // Check for the required config fields if a customSave function isn't provided
      if (!usingCustomSave) {
        if (!angular.isString(autoSaveConfig.restCollection)) {
          throw new Error('bulb-auto-save\'s value Object must contain a (String) restCollection field');
        }
        if (!angular.isString(autoSaveConfig.restId)) {
          throw new Error('bulb-auto-save\'s value Object must contain a (String) restId field');
        }
        if (!angular.isString(attrs.name)) {
          throw new Error('bulb-auto-save requires a name attribute');
        }
      }

      if (autoSaveConfig.callback && !angular.isFunction(autoSaveConfig.callback)) {
        throw new Error('bulb-auto-save\'s value Object callback parameter must be a function if provided');
      }
      if (autoSaveConfig.getter && !angular.isFunction(autoSaveConfig.getter)) {
        throw new Error('bulb-auto-save\'s value Object getter parameter must be a function if provided');
      }

      // ngModel.$modelValue and ngModel.$viewValue are undefined at this point (Angular 1.3.3)
      let lastValue = autoSaveConfig.getter ? autoSaveConfig.getter() : $parse(attrs.ngModel)(scope);

      ngModelController.$viewChangeListeners.push(() => {
        const currentValue = autoSaveConfig.getter ? autoSaveConfig.getter() : ngModelController.$modelValue;
        if (currentValue !== lastValue) {
          if (usingCustomSave) {
            SerialSaveService.save({
              save: () => autoSaveConfig.customSave(),
            }).then(() => {
              // Update share status to reflect that the unit has been edited:
              const ShareTransition = UnitStateStore.getShareTransitionEnum();
              UnitStateStore.transitionShareStatus(ShareTransition.EDIT);
            });
          } else {
            const payload = {};
            payload[ngModelController.$name] = currentValue;

            BulbAutoSaveService.autoSave(
              autoSaveConfig.restId,
              autoSaveConfig.restCollection,
              payload,
              autoSaveConfig.callback,
            );
          }
        }
        lastValue = currentValue;
      });
    },
  };
}
